import { render, staticRenderFns } from "./SubscribeButton.vue?vue&type=template&id=0464748c&"
import script from "./SubscribeButton.vue?vue&type=script&lang=ts&"
export * from "./SubscribeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports